import d1 from "../doors/d1.jpeg"
import d2 from "../doors/d2.jpeg"
import d3 from "../doors/d3.jpeg"
import d4 from "../doors/d4.jpeg"
import d5 from "../doors/d5.jpeg"
import d6 from "../doors/d6.jpeg"
import d7 from "../doors/d7.jpeg"
import d8 from "../doors/d8.jpeg"
import d9 from "../doors/d9.jpeg"
import d10 from "../doors/d10.jpeg"
import d11 from "../doors/d11.jpeg"
import d12 from "../doors/d12.jpeg"
import d13 from "../doors/d13.jpeg"
import d14 from "../doors/d14.jpeg"
import d15 from "../doors/d15.jpeg"


function Doors() {
  return (

    <div class="container">
      <h1>Doors Work</h1>
      <h4>A few highlights from our recent work.</h4>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <div class="col">
          <div class="card shadow-sm">
            <img src={d1} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d2} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d3} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d4} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d5} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d6} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d7} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d8} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d9} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d10} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d11} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>

        <div class="col">
          <div class="card shadow-sm">
            <img src={d12} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d13} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d14} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={d15} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
      </div>
      <p><a class="btn btn-success" href="https://www.instagram.com/invites/contact/?igsh=1izl3bvvj2uj3&utm_content=zvshzkp">View more &raquo;</a></p>
      <hr class="featurette-divider" /></div>

  );
}

export default Doors;
